// NOTE: Single source of truth for the per-platform Capacitor appId. Imported
// from BOTH the bundle (mobile-app.module.ts → Auth0 callbackUri) and the
// per-platform Capacitor templates (capacitor.config-{android,ios}.ts → CLI
// reads them at `cap sync` time to write applicationId / BUNDLE_IDENTIFIER).
//
// IMPORTANT: keep this file as a leaf module — no imports, no side effects.
// The Capacitor CLI transpiles `.ts` configs with esbuild on the fly; pulling
// in browser-only or Angular-specific deps from here would break that
// transpile.
export const MOBILE_APP_IDS = {
  android: 'com.sidedrawer.app',
  ios: 'com.app.sidedrawer',
} as const;

export type MobileAppPlatform = keyof typeof MOBILE_APP_IDS;
